module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "pt01"
    }
  }, [_c('div', {
    staticClass: "partHead"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('h2', {
    staticClass: "partTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE PRINCE’S CHOICE")])]), _vm._v(" "), _c('p', {
    staticClass: "partSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rebecca Winters")])])])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "partBody"
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page07"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c3c354","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426881688_pt01.vue
// module id = 69
// module chunks = 0